import './pdf.less';

import React from 'react';

import PdfMobileSection from './pdf_no_embed_mobile.jsx';
import PdfNoEmbedDesktopSection from './pdf_no_embed_desktop.jsx';
import EmbeddedIframeSection from '../shared/embedded_iframe_section.jsx';

const PdfSection = ({ isMobile, canEmbedPdf, ...props }) => {
  if (!props.contentItem || !props.asset) {
    return null;
  }

  if (isMobile) {
    return <PdfMobileSection {...props} />;
  }
  if (!canEmbedPdf) {
    return <PdfNoEmbedDesktopSection {...props} />;
  }
  return (
    <EmbeddedIframeSection
      uuid={props.contentItem.uuid}
      height={props.height}
      iframeSrc={props.asset.link}
      iframeTitle={props.contentItem.iframe_title || 'Embedded PDF'}
      bringToFore={props.bringToFore}
    />
  );
};

export default PdfSection;
